import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Checkbox,
  Paper,
  Grid,
  Typography,
  Box,
  Button,
  Badge,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';

import SelectReact from 'react-select';

import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

import i18n from '../../i18n';
import { FREELANCE, FULLTIME, CONTRACT } from '../../constants/general';

import '../../assets/stylesheets/BookingForm.css';

class DateLocationSelector extends Component {

  selectStyle = {
    menu: (baseStyles) => ({
      ...baseStyles,
      zIndex: 2
    })
  };

  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      openedPopoverId: null,
    };
  }

  handleClick = (event, popoverId) => {
    this.setState({
      anchorEl: event.currentTarget,
      openedPopoverId: popoverId,
    });
  };

  handleClose = () => {
    this.setState({ anchorEl: null, openedPopoverId: null });
  };

  handleIncludedTypeChange = (event) => {
    const { onIncludedEmployeeTypeChange } = this.props;
    onIncludedEmployeeTypeChange(
      event.currentTarget.name,
      event.currentTarget.checked
    );
  };

  render() {
    const {
      selectedDate,
      fetchDateSchedule,
      selectedLocation,
      locations,
      onLocationChange,
      includedEmployeeTypes,
      getSuggestedEmployees,
      unfilledPositions,
      lowAbilityTier,
      unsetProductTier,
    } = this.props;

    const { fullTime, contract, freelance } = includedEmployeeTypes;

    const { openedPopoverId, anchorEl } = this.state;

    return (
      <Paper className="bookingForm">
        <Grid container spacing={0}>
          <Grid item xs={3} className="bookingFormLabel">
            <Typography component="div">
              <Box fontSize="h5.fontSize" fontWeight="fontWeightBold">
                {i18n.t('location')}
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={9}>
            <SelectReact
              fullWidth
              value={selectedLocation}
              className="bookingSelectField"
              options={locations}
              styles={this.selectStyle}
              onChange={onLocationChange}
            />
          </Grid>
          <Grid item xs={3} className="bookingFormLabel">
            <Typography component="div">
              <Box fontSize="h5.fontSize" fontWeight="fontWeightBold">
                {i18n.t('booking:date')}
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={9}>
            <MuiPickersUtilsProvider
              utils={DateFnsUtils}
              className="bookingSelectField"
            >
              <DatePicker value={selectedDate} onChange={fetchDateSchedule} />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={12} className="bookingFormLabelExtra">
            <Typography component="div">
              <Box fontSize="h5.fontSize" fontWeight="fontWeightBold">
                {i18n.t('booking:includedEmployeeTypes')}
                :
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Checkbox
              name={FULLTIME}
              checked={fullTime}
              onChange={this.handleIncludedTypeChange}
            />
          </Grid>
          <Grid item xs={3} className="bookingFormLabel">
            <Typography component="div">
              <Box fontSize="h5.fontSize" fontWeight="fontWeightBold">
                {i18n.t('fullTime')}
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Checkbox
              name={CONTRACT}
              checked={contract}
              onChange={this.handleIncludedTypeChange}
            />
          </Grid>
          <Grid item xs={3} className="bookingFormLabel">
            <Typography component="div">
              <Box fontSize="h5.fontSize" fontWeight="fontWeightBold">
                {i18n.t('contract')}
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Checkbox
              name={FREELANCE}
              checked={freelance}
              onChange={this.handleIncludedTypeChange}
            />
          </Grid>
          <Grid item xs={3} className="bookingFormLabel">
            <Typography component="div">
              <Box fontSize="h5.fontSize" fontWeight="fontWeightBold">
                {i18n.t('freelance')}
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Button
              onClick={getSuggestedEmployees}
              className="saveButtonBookingForm ssensePrimary suggestButton"
            >
              {i18n.t('booking:suggestEmployees')}
            </Button>
          </Grid>

          <Grid container style={{ marginTop: '20px' }}>
            {unfilledPositions.length > 0 && (
              <Grid item>
                <Badge color="error" badgeContent={unfilledPositions.length}>
                  <Button
                    variant="contained"
                    onClick={(e) => this.handleClick(e, 1)}
                  >
                    {i18n.t('booking:unfilled')}
                  </Button>
                  <Popover
                    open={openedPopoverId === 1}
                    anchorEl={anchorEl}
                    onClose={this.handleClose}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                  >
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>{i18n.t('booking:location')}</TableCell>
                          <TableCell>{i18n.t('booking:position')}</TableCell>
                          <TableCell>
                            {i18n.t('booking:requestedTier')}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {unfilledPositions.map((row) => (
                          <TableRow key={row.location + row.position + row.abilityTier}>
                            <TableCell>{row.location}</TableCell>
                            <TableCell>{row.position}</TableCell>
                            <TableCell>{row.abilityTier}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Popover>
                </Badge>
              </Grid>
            )}
            {lowAbilityTier.length > 0 && (
              <Grid item>
                <Badge color="error" badgeContent={lowAbilityTier.length}>
                  <Button
                    variant="contained"
                    onClick={(e) => this.handleClick(e, 2)}
                  >
                    {i18n.t('booking:lowTier')}
                  </Button>
                  <Popover
                    open={openedPopoverId === 2}
                    anchorEl={anchorEl}
                    onClose={this.handleClose}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                  >
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>{i18n.t('booking:location')}</TableCell>
                          <TableCell>{i18n.t('booking:position')}</TableCell>
                          <TableCell>{i18n.t('booking:employee')}</TableCell>
                          <TableCell>
                            {i18n.t('booking:requestedTier')}
                          </TableCell>
                          <TableCell>{i18n.t('booking:actualTier')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {lowAbilityTier.map((row) => (
                          <TableRow key={row.location + row.position + row.employee}>
                            <TableCell>{row.location}</TableCell>
                            <TableCell>{row.position}</TableCell>
                            <TableCell>{row.employee}</TableCell>
                            <TableCell>{row.requestedAbilityTier}</TableCell>
                            <TableCell>{row.actualAbilityTier}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Popover>
                </Badge>
              </Grid>
            )}
            {unsetProductTier.length > 0 && (
              <Grid item>
                <Badge color="error" badgeContent={unsetProductTier.length}>
                  <Button
                    variant="contained"
                    onClick={(e) => this.handleClick(e, 3)}
                  >
                    {i18n.t('booking:unsetTier')}
                  </Button>
                  <Popover
                    open={openedPopoverId === 3}
                    anchorEl={anchorEl}
                    onClose={this.handleClose}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                  >
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>{i18n.t('booking:location')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {unsetProductTier.map((row) => (
                          <TableRow key={row.location}>
                            <TableCell>{row.location}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Popover>
                </Badge>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

DateLocationSelector.propTypes = {
  selectedDate: PropTypes.instanceOf(Date).isRequired,
  fetchDateSchedule: PropTypes.func.isRequired,
  selectedLocation: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.array])
  ).isRequired,
  locations: PropTypes.arrayOf(PropTypes.object).isRequired,
  onLocationChange: PropTypes.func.isRequired,
  includedEmployeeTypes: PropTypes.objectOf(PropTypes.bool).isRequired,
  onIncludedEmployeeTypeChange: PropTypes.func.isRequired,
  getSuggestedEmployees: PropTypes.func.isRequired,
  unfilledPositions: PropTypes.arrayOf(PropTypes.object).isRequired,
  lowAbilityTier: PropTypes.arrayOf(PropTypes.object).isRequired,
  unsetProductTier: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default DateLocationSelector;
